import { Injectable } from '@angular/core';
import { ToastController, AlertController, LoadingController, createAnimation } from '@ionic/angular';
import { Preferences } from '@capacitor/preferences';

const TOAST_ANIM_MS = 180;

function toastEnterAnimation(baseEl: HTMLElement, opts?: string) {
  const root = baseEl.shadowRoot ?? baseEl;
  const wrapperEl = root.querySelector('.toast-wrapper');
  if (!wrapperEl) return createAnimation();

  const position = opts ?? 'bottom';
  if (position !== 'bottom') {
    return createAnimation()
      .addElement(wrapperEl)
      .duration(TOAST_ANIM_MS)
      .easing('ease-out')
      .fromTo('opacity', '0', '1');
  }

  return createAnimation()
    .addElement(wrapperEl)
    .duration(TOAST_ANIM_MS)
    .easing('ease-out')
    .fromTo('opacity', '0', '1')
    .fromTo('transform', 'translateY(100%)', 'translateY(0)');
}

function toastLeaveAnimation(baseEl: HTMLElement, opts?: string) {
  const root = baseEl.shadowRoot ?? baseEl;
  const wrapperEl = root.querySelector('.toast-wrapper');
  if (!wrapperEl) return createAnimation();

  const position = opts ?? 'bottom';
  if (position !== 'bottom') {
    return createAnimation()
      .addElement(wrapperEl)
      .duration(TOAST_ANIM_MS)
      .easing('ease-in')
      .fromTo('opacity', '1', '0');
  }

  return createAnimation()
    .addElement(wrapperEl)
    .duration(TOAST_ANIM_MS)
    .easing('ease-in')
    .fromTo('opacity', '1', '0')
    .fromTo('transform', 'translateY(0)', 'translateY(100%)');
}

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  isLoading = false;
  constructor(
      public loadingCtrl: LoadingController,
      public toastController: ToastController
  ) { }

  async presentToast(msg: string, duration: number = 3000): Promise<void> {
    const tabsVisible = !!document.querySelector('ion-tab-bar');
    const toast = await this.toastController.create({
      message: msg,
      duration,
      position: 'bottom',
      cssClass: tabsVisible ? ['white-toast', 'toast-above-tabs'] : 'white-toast',
      // enterAnimation: toastEnterAnimation,
      // leaveAnimation: toastLeaveAnimation
    });
    await toast.present();
  }
  
  // Moderation refusals carry a title and a body (Content Safety Master Spec
  // §14/§15), and the person needs to actually notice their message did not
  // send — hence the longer duration and the dismiss button.
  async presentBlockedToast(header: string, msg: string): Promise<void> {
    const tabsVisible = !!document.querySelector('ion-tab-bar');
    const toast = await this.toastController.create({
      header,
      message: msg,
      duration: 6000,
      position: 'bottom',
      cssClass: tabsVisible ? ['white-toast', 'toast-above-tabs'] : 'white-toast',
      buttons: [{ text: 'OK', role: 'cancel' }],
    });
    await toast.present();
  }

  async presentTopToast(msg: string, duration: number = 3000): Promise<void> {
    const tabsVisible = !!document.querySelector('ion-tab-bar');
    const toast = await this.toastController.create({
      message: msg,
      duration,
      position: 'top',
      cssClass: tabsVisible ? ['white-toast', 'toast-above-tabs'] : 'white-toast',
      // If you want a different style for top toasts, you can use:
      // cssClass: [...(tabsVisible ? ['white-toast', 'toast-above-tabs'] : ['white-toast']), 'top-toast']
    });
    await toast.present();
  }

  async present(msg) {
    this.isLoading = true;
    return await this.loadingCtrl.create({
      // duration: 5000,
      spinner: 'bubbles',
    }).then(a => {
      a.present().then(() => {
        console.log('presented');
        if (!this.isLoading) {
          a.dismiss().then(() => console.log('abort presenting'));
        }
      });
    });
  }

  async dismiss() {
    this.isLoading = false;
    return await this.loadingCtrl.dismiss().then(() => console.log('dismissed'));
  }



  // For storage Preferences`
  async setString(key: string, value: string) {
    await Preferences.set({ key, value });
  }

  async getString(key: string): Promise<{ value: any }> {
      return (await Preferences.get({ key }));
  }
}
